import React, { useEffect, useState } from 'react';
import { useApi } from '../hooks/useApi';
import { useAuth } from '../context/AuthContext';
import { Save } from 'lucide-react';
import toast from 'react-hot-toast';

// ============================================================
// Masail.js

// ============================================================
export function Masail() {
  const api = useApi();
  const { can } = useAuth();
  const [settings, setSettings] = useState({ masail_ai_prompt: '', masail_footer: '', masail_max_length: '800' });
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => { load(); }, []);
  async function load() {
    setLoading(true);
    const s = await api.get('/masail-settings');
    if (s?.settings) setSettings(p => ({ ...p, ...s.settings }));
    setLoading(false);
  }
  async function save() {
    setSaving(true);
    const d = await api.post('/masail-settings', { updates: settings });
    if (d?.success) toast.success('Save ho gaya!'); else toast.error(d?.error || 'Error');
    setSaving(false);
  }

  if (loading) return <div style={{ textAlign: 'center', padding: 60 }}><span className="spinner" style={{ width: 32, height: 32 }} /></div>;

  return (
    <div className="page">
      <div className="page-header">
        <div className="section-title">📖 Masail Settings</div>
        <div className="section-sub">AI masail response aur settings configure karein</div>
      </div>

      <div style={{ maxWidth: 640 }}>
        <div className="card">
          <div style={{ fontSize: 13, fontWeight: 600, color: 'var(--text-primary)', marginBottom: 20 }}>🤖 AI Masail Configuration</div>

          <div className="field">
            <label className="label">AI System Prompt (Fiqh Hanafi instructions)</label>
            <textarea className="textarea" value={settings.masail_ai_prompt} onChange={e => setSettings(p => ({ ...p, masail_ai_prompt: e.target.value }))} disabled={!can('settings')} style={{ minHeight: 160, fontFamily: 'monospace', fontSize: 12 }} placeholder="Aap ek Islamic scholar hain jo Fiqh Hanafi ke mutabiq jawab dete hain..." />
            <div style={{ fontSize: 11, color: 'var(--text-muted)', marginTop: 4 }}>Yeh AI ko instructions deta hai ke kaise jawab de</div>
          </div>

          <div className="field">
            <label className="label">Max Response Length (characters)</label>
            <input className="input" type="number" value={settings.masail_max_length} onChange={e => setSettings(p => ({ ...p, masail_max_length: e.target.value }))} disabled={!can('settings')} style={{ maxWidth: 140 }} />
          </div>

          <div className="field">
            <label className="label">Footer (har jawab ke baad)</label>
            <input className="input" value={settings.masail_footer} onChange={e => setSettings(p => ({ ...p, masail_footer: e.target.value }))} disabled={!can('settings')} placeholder="Allama Hassan Raza Naqshbandi 🌹" />
          </div>

          <div style={{ padding: '10px 14px', background: 'var(--emerald-900)', border: '1px solid var(--emerald-700)', borderRadius: 8, fontSize: 12, color: 'var(--emerald-200)', marginBottom: 16 }}>
            💡 Bot text masail ke liye AI use karta hai. Voice masail seedha forward hoti hain admin ko.
          </div>

          {can('settings') && (
            <button className="btn btn-primary" onClick={save} disabled={saving}>
              {saving ? <span className="spinner" style={{ width: 14, height: 14 }} /> : <Save size={14} />}
              {saving ? ' Saving...' : ' Save Karein'}
            </button>
          )}
        </div>
      </div>
    </div>
  );
}